import { jwtDecode } from "jwt-decode";
import store from "../redux/store/store";
import { storeUserDetails } from "../redux/actions/authActions";
const API_BASE_URL = process.env.REACT_APP_API_URL + "/api/"
let refreshPromise = null;
export const isTokenValid = (token) => {
  if (!token) {
    return false;
  }

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000; // current time in seconds
    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Invalid token:', error);
    return false;
  }
};
export const refreshAccessToken = async () => {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async () => {
    try {
      const refresh = localStorage.getItem('refreshToken');
      if (!refresh) return null;

      const response = await fetch(`${API_BASE_URL}token/refresh/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refresh }),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('session_minutes');
          window.location.href = '/login';
        }
        return null;
      }

      const data = await response.json();

      // Update localStorage for both tokens
      localStorage.setItem('accessToken', data.access);
      if (data.refresh) {
        localStorage.setItem('refreshToken', data.refresh);
      }

      // Update BOTH tokens in Redux, not just access
      store.dispatch({
        type: 'STORE_TOKENS',
        payload: {
          accessToken: data.access,
          refreshToken: data.refresh ?? refresh // fall back to current if not rotated
        }
      });

      return { access: data.access, refresh: data.refresh ?? refresh };

    } catch (error) {
      console.error('Error refreshing token:', error);
      throw error;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
};
export const handleTokenExpiry = async (refreshToken) => {
  try {
    const response = await fetch(`${API_BASE_URL}refresh-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refreshToken }),
    });

    if (response.ok) {
      const data = await response.json();
      return data; // Return the new tokens (access and refresh)
    } else {
      throw new Error('Unable to refresh token');
    }
  } catch (error) {
    console.error('Error refreshing token:', error);
    throw error;
  }
};

export const isTokenExpired = (token) => {
  const decodedToken = jwtDecode(token);
  const currentTime = Date.now() / 1000;
  return decodedToken.exp < currentTime;
};

export const accessTokenId = async (session_id) => {
  if (refreshPromise) {
    return refreshPromise;
  }
  refreshPromise = (async () => {
    try {
      const response = await fetch(`${API_BASE_URL}unified/refresh/session/?session_id=${session_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        if (response.status === 401) {
          // Handle expired or invalid refresh token
          // Clear tokens from local storage
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('session_minutes');
          // Optional: Trigger any additional logout actions, e.g., redirect
          window.location.href = '/login';
        }
        return null;

      }

      const data = await response.json();
      const newAccessToken = data.access;
      localStorage.setItem('accessToken', newAccessToken);
      localStorage.setItem('refreshToken', data.refresh);
      localStorage.setItem('permissions', data.permissions);
      localStorage.setItem('partner_id', data.partner_id);
      store.dispatch(storeUserDetails({
        user_id: data.user_id,
        accessToken: data.access,
        refreshToken: data.refresh,
        permissions: data.permissions
      }));
      return newAccessToken;
    } catch (error) {
      console.error('Error refreshing token:', error);
      throw error;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
}
